<mat-form-field appearance="outline" class="combo-input-field">
    <mat-label>{{ label() }}</mat-label>
    <input
        type="text"
        matInput
        [placeholder]="placeholder()"
        [(ngModel)]="inputValue"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onInputChange($event)"
        [matAutocomplete]="auto"
        [disabled]="disabled"
    />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    @for(option of filteredOptions; track option){
    <mat-option [value]="option">
        {{ option }}
    </mat-option>
    }
    </mat-autocomplete>
</mat-form-field>